import { FC, PropsWithChildren } from 'react'

/** Props for the shared panel layout component. */
type PanelProps = PropsWithChildren<{
  as?: 'div' | 'section' | 'article'
  className?: string
  ariaLabel?: string
}>

/**
 * Section/panel wrapper with consistent padding and background.
 * Use `as` to choose a semantic element and `ariaLabel` for accessibility.
 */
export const Panel: FC<PanelProps> = ({ as = 'div', children, className, ariaLabel }) => {
  const Tag = as
  const classes = [
    'rounded-xl bg-brand-smoky/80 px-6 py-10 sm:px-10 shadow-[0_18px_40px_rgba(0,0,0,0.35)] ring-1 ring-black/20',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <Tag className={classes} aria-label={ariaLabel}>
      {children}
    </Tag>
  )
}
